export const DATE_KEY_FORMAT = 'YYYY-MM-DD';

export const EXTRA_LONG_DATE_FORMAT = 'llll';

export const LONG_DATE_FORMAT = 'lll';

export const SHORT_DATE_FORMAT = 'LT';

export const ZERO_COACH_SCHEDULE = '0'.repeat(24 * 7);

export const HORIZONTAL_LAYOUT_WIDTH = 875;
